import React from 'react';
import { Messages } from '../../logic/components';

const HelpRoute = () => {
  return (
    <div
      className="container"
      style={{
        height: 'calc(100vh - 60px)',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
      }}
    >
      <Messages />
    </div>
  );
};

export default React.memo(HelpRoute);
